{
    "administration": "Administration",
    "ai": "AI settings",
    "ai_usage": "AI usage",
    "alerts": "Alerts",
    "api_docs": "API reference",
    "audit": "Audit trail",
    "branding": "Branding",
    "cc_chatbot": "Chatbot",
    "cc_configuration": "Queues & agents",
    "cc_console": "Agent console",
    "cc_ivr": "IVR designer",
    "cc_licensing": "CC licensing",
    "cc_reporting": "Contact centre reports",
    "cc_wallboard": "Wallboard",
    "close_menu": "Close menu",
    "collapse_sidebar": "Collapse sidebar",
    "command_palette": "Command palette",
    "complaint_configuration": "Complaint rules",
    "complaints": "Complaints",
    "compliance": "RFP compliance",
    "contact_centre": "Contact centre",
    "customers": "Customers",
    "dashboard": "Dashboard",
    "demo": "Demo control",
    "events": "Spine events",
    "expand_sidebar": "Expand sidebar",
    "guide": "User guide",
    "health": "System health",
    "import": "Import",
    "integrations": "Integrations",
    "integrations_health": "Integration health",
    "integrations_keys": "API keys",
    "integrations_simulators": "Integration simulators",
    "integrations_webhooks": "Webhooks",
    "knowledge": "Knowledge base",
    "main_navigation": "Main navigation",
    "mark_all_read": "Mark all as read",
    "measurement": "Experience",
    "mex_actions": "Improvement actions",
    "mex_dashboard": "Experience",
    "mex_distributions": "Survey sending",
    "mex_journeys": "Survey journeys",
    "mex_simulators": "Survey channels",
    "mex_surveys": "Surveys",
    "mex_verbatims": "Verbatims",
    "no_alerts": "No new notifications",
    "notifications": "Notifications",
    "open_menu": "Open menu",
    "operations": "Operations",
    "profile": "My profile",
    "queue": "Branch queues",
    "queue_appointments": "Appointments",
    "queue_configuration": "Services & counters",
    "queue_hardware": "Branch hardware",
    "queue_simulator": "Branch simulator",
    "reports": "Reports",
    "reports_builder": "Report builder",
    "reports_executive": "Executive dashboard",
    "reports_runs": "Report history",
    "reports_schedules": "Scheduled reports",
    "search_placeholder": "Search customers, complaints, tickets…",
    "security": "Security",
    "segments": "Segments",
    "settings": "Settings",
    "showcase": "Start here",
    "skip_to_content": "Skip to main content",
    "user_menu": "Account menu",
    "users": "Users & roles",
    "view_layouts": "Screen layouts"
}
